<template>
    <div class="hiq-search-app__load-more" v-if="canLoadMore">
        <button class="hiq-search-app__load-more--button hiq-load-more" @click="loadMore">{{translations.loadMore}}</button>
    </div>
</template>

<script>
import { newSearch } from '../store/actions';
export default {
    name: 'load-more',
    methods: {
        loadMore() {
            const index = this.items.length;
            this.$store.commit({
                type: 'setPage',
                payload: this.page + 1
            });
            this.$store.dispatch(newSearch());
            this.focusFirstNewItem(index)
        },
        focusFirstNewItem(index) {
            const items = document.querySelectorAll('.hiq-search-app__result-item--link');
            if(items && items[index]) {
                items[index].focus();
            } else if(items) {
                setTimeout(() => { this.focusFirstNewItem(index) }, 100);
            }
        }
    },
    computed: {
        canLoadMore() {
            return this.$store.state.searchResult.canLoadMore;
        },
        page() {
            return this.$store.state.searchResult.page;
        },
        translations() {
            return this.$store.state.translations;
        },
        items() {
            return this.$store.state.searchResult.items;
        },
    }
}
</script>